import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getHistories: function ({limit = 100, page = 1, user, eventDate, serviceProvider}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [
      `page=${page}`,
      `limit=${limit}`,
      'sort[]=eventDate&sort[]=-1',
      `serviceProvider[]=${serviceProvider}`
    ]
    if (user) query.push(`user[]=${user}`)
    if (eventDate) query.push(`eventDate[]=${eventDate}`)
    return instCred.get('serviceproviderhistories?' + query.join('&'))
  },
  createHistory: function (history) {
    history.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('serviceproviderhistories', history)
  },
  updateHistory: function (history) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('serviceproviderhistories/' + history.id, history)
  },
  deleteHistory: function (historyId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('serviceproviderhistories/' + historyId)
  }
}



// WEBPACK FOOTER //
// ./src/api/ServiceProviderHistory/api.js